import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const groupNameColumn = <T extends { groupName: string }>(
  t: TFunction,
): ColumnType<T> => ({
    title: t('Group name'),
    dataIndex: 'groupName',
  });
